import { InnerBox } from "@/components/elements/InnerBox";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { ItemInfo } from "@/components/commons/ItemInfo";

type TLearnerOtherInfoDetailProps = {
  data?: Partial<TLearnerForm>;
};

export const LearnerOtherInfoDetail: FC<TLearnerOtherInfoDetailProps> = ({ data }) => {
  return (
    <Stack gap={2}>
      <InnerBox
        title={<Typography variant="head20Bold">その他の情報</Typography>}
        showDivider={false}
      >
        <ItemInfo label="メモ" value={data?.memo} type="textArea" />
      </InnerBox>
    </Stack>
  );
};
